import React from "react";

const HamburgerButton = ({ open, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
      aria-expanded={open}
      className="
        relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl
        border border-slate-200 bg-white text-slate-900 shadow-sm transition
        hover:-translate-y-0.5 hover:border-orange-300 hover:text-orange-600
        focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500
        dark:border-white/10 dark:bg-slate-900 dark:text-white dark:hover:border-orange-400
        sm:h-11 sm:w-11 lg:hidden
      "
    >
      <span
        className={`absolute h-[2px] w-5 rounded-full bg-current transition duration-300 sm:w-6 ${
          open ? "translate-y-0 rotate-45" : "-translate-y-2"
        }`}
      />
      <span
        className={`absolute h-[2px] w-5 rounded-full bg-current transition duration-300 sm:w-6 ${
          open ? "opacity-0" : "opacity-100"
        }`}
      />
      <span
        className={`absolute h-[2px] w-5 rounded-full bg-current transition duration-300 sm:w-6 ${
          open ? "translate-y-0 -rotate-45" : "translate-y-2"
        }`}
      />
    </button>
  );
};

export default HamburgerButton;